module.exports = __webpack_public_path__ + "static/slider_3-18e16402fcc64796bd49fa12ee13667c.jpg";